<template>
  <div class="withdrawal">
    <van-dialog
      v-model="isVisible"
      className="dialog"
      :before-close="confirm"
      showCancelButton
      confirmButtonColor="#FF6B31"
      cancelButtonColor="#ccc"
    >
      <div class="dialog-title" slot="title">
        <div class="dialog-title-txt">绑定</div>
      </div>
      <div class="dialog-content">
        <div>
          <div>正在设置{{userName}}的账号为{{type == 1 ? '提现账号' : '入网签约人'}}！<br />请输入验证码完成绑定。</div>
        </div>
        <div class="form-box">
          <van-form>
            <van-field v-model="phoneNumber" maxlength="11" readonly>
              <div class="left-icon-box" slot="left-icon">
                <img :src="icons.phone" />
              </div>
            </van-field>
            <van-field
              v-model="code"
              type="number"
              maxlength="6"
              placeholder="请输入验证码"
            >
              <div class="left-icon-box" slot="left-icon">
                <img :src="icons.lock" />
              </div>
              <van-button
                class="code-btn"
                slot="button"
                size="small"
                plain
                color="#FF6B31"
                :disabled="isCodeDisabled"
                @click="getCode"
              >
                {{ isCodeDisabled ? `${timeString} 秒` : timeString }}
              </van-button>
            </van-field>
          </van-form>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
const COUNTDOWN_TIME = 120;
import avatar from "@/assets/icons/avatar.png";
export default {
  props: {
    isBindingPop: {
      type: Boolean,
      default: false
    },
    currentAccount:{
      type: Array,
      default() {
        return []
      }
    },
    phoneNumber: [String,Number]
  },
  computed: {
    isVisible: {
      get() {
        return this.isBindingPop
      },
      set(newVal) {
        this.$emit('update:isBindingPop',newVal)
      }
    },
    userName() {
      let userName = ''
      this.currentAccount.forEach((item,index) => {
       userName = `${userName}${item.userName}${index != this.currentAccount.length -1 ? '、':''}`
      });
      return userName
    },
    type() {
      return this.$route.query.type
    }
  },
  data() {
    return {
      avatar,
      code: '',
      icons: {
        phone: require("@/assets/icons/login_phone.png"),
        lock: require("@/assets/icons/login_lock.png"),
      },
      isCodeDisabled: false,
      timeString: "获取验证码",
      userInfo: {}
    };
  },
  methods: {
    onClose() {
      this.isVisible = false;
    },
    async getCode() {
      let userIds = []
      this.currentAccount.forEach(item => {
        userIds.push(item.userId)
      });
      let parmes = {
        phoneNumber: this.phoneNumber,
        smsType: 1,
        userIds,
        type: this.type
      };
      this.$api.withdrawal.getWithdrawalSms(parmes).then(() => {
        this.startCountdown();
      });
    },
    confirm(action, done) {
      if (action == 'confirm') {
        if (!this.code) {
          this.$toast('请输入验证码')
          done(false);
          return
        }
        let userIds = []
        this.currentAccount.forEach(item => {
          userIds.push(item.userId)
        })
        let parames = {
          userIds,
          phoneNumber: this.phoneNumber,
          code: this.code,
          type: this.type
        }
        this.$api.withdrawal.bindingVerify(parames)
          .then(res => {
            done();
            this.$toast('绑定成功')
            setTimeout(() => {
              this.$router.go(-1) 
            }, 500);
          }).catch(err => {
            done(false);
          })
        return
      }
      done()
    },
    startCountdown() {
      this.timeString = COUNTDOWN_TIME;
      this.countDown();
    },
    countDown() {
      this.isCodeDisabled = true;
      this.timeString = this.timeString - 1;
      if (this.timeString <= 0) {
        this.timeString = "获取验证码";
        this.isCodeDisabled = false;
        return;
      }
      this.timer = setTimeout(this.countDown, 1000);
    },
  },
};
</script>

<style lang="stylus" scoped>
.withdrawal {
  height: 100vh;
  background: #F4F4F4;
}
.inputVal
  width 30%
  border: none
  background: none;
.dialog
  border-radius: 12px
  .dialog-title
    position relative
    &-text
      text-align: center
    .close-icon
      display: inline-block
      position absolute
      right 10px
      top 0

  .dialog-content
    text-align center
    padding 0 15px
    line-height 1.4
    .amount {
      color: #FF6B31;
      font-weight: bold;
      font-size: 24px;
      .amount-number {
        font-size: 30px;
      }
    }
    >>> .van-field .van-field__value input
      color #FF6B31
  >>> .van-dialog__header
    padding 20px 0
  >>> .van-dialog__footer button

    padding 15px 0

    height: auto
    line-height 1
    color #49a9f0

  .field-item
    // margin 15px 0
    display: flex
    justify-content: space-between
    align-items: center
    padding 10px 16px
    font-size 14px
    background-color: #fff
    border-radius: 8px
    &-title
      color #323233
  .form-box
    padding 15px
    .left-icon-box
      position relative
      top 2px
      margin-right 8px
      width 22px
      height: 24px
      >img
        width 100%
        height: auto

    .input-left-icon
      line-height 33px
      // margin-right 15px
    .input-left-icon1
      // margin-right 15px
    .code-btn
      padding 0
      border none
      height: 24px
      line-height 24px
      font-size 14px
  .btn-box
    margin 20px 16px
  .tips-content
    color #777
    font-size 12px
    line-height 18px
  .block-btn
    border-radius: 25px
    font-size 16px
    color #FFF
    background linear-gradient(#FF8820, #FF6B31)

  .success-box
    padding 15px
    .info-box
      padding 15px 0
      text-align: center
      >div
        margin-top 15px
.ft24
  font-size:24px;
  font-weight: bold;
  color:#000
</style>
